import { WHY_POINTS } from '../data/content';
import './WhyAiva.css';

export default function WhyAiva() {
  return (
    <section id="why" className="section-divider">
      <div className="section-wrap">
        <span className="eyebrow">Why Aiva</span>
        <h2 className="sec-title">Built different. For business.</h2>
        <p className="sec-sub">
          Most chatbots are glorified FAQs. Aiprus builds agents that reason, retrieve,
          integrate, and act — solving real business problems at scale.
        </p>
        <div className="why__grid">
          {WHY_POINTS.map(p => (
            <div key={p.title} className="why-card">
              <div className="why-card__icon">{p.icon}</div>
              <h3 className="why-card__title">{p.title}</h3>
              <p className="why-card__desc">{p.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
